export default "__VITE_ASSET__C7jEWce9__"